import { render, staticRenderFns } from "./FixedAssetsList.vue?vue&type=template&id=4c140392"
import script from "./FixedAssetsList.vue?vue&type=script&lang=js"
export * from "./FixedAssetsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports